import { IApplicationState } from '../../types/redux';

export function getComments(state: IApplicationState) {
  return state.comments;
}
